import UseConfig from './UseConfig';

/**
 * 获取common-ui静态资源链接
 * @param value
 * @param upperFileName 上一级文件名，默认是images
 * @returns {string}
 */
export function getOfficialAssetUrl(value: string, upperFileName = 'images') {
  return `${UseConfig.assetOfficialUrl}/${upperFileName}${value}`;
}

/**
 * 获取common-ui静态资源链接
 * @param value
 * @param upperFileName 上一级文件名，默认是images
 * @param compatibleSuffix
 * @returns {string}
 */
export function getOfficialAssetUrlWithWebp(
  value: string,
  upperFileName = 'images',
  compatibleSuffix?: 'jpg' | 'jpeg' | 'png'
) {
  const suffix = UseConfig.assetSupportWebP
    ? 'webp'
    : compatibleSuffix || 'png';
  return getOfficialAssetUrl(`${value}.${suffix}`, upperFileName);
}

/**
 * 获取Resource静态资源链接
 * @param value
 * @returns {string}
 */
export function getResourceUrl(value: string) {
  return `${UseConfig.assetOfficialUrl}${value}`;
}
